import { Injectable } from '@angular/core';
import {ApiService} from '../global/api.service';
import {Competition, CompetitionParticipant} from '../../types/models';

@Injectable({
  providedIn: 'root'
})
export class CompetitionService {

  constructor(private api: ApiService) { }

  async getAll(): Promise<Competition[]> {
    return this.api.get('competition');
  }

  async get(id: string): Promise<Competition> {
    return this.api.get('competition/' + id);
  }

  async participate(competition: Competition): Promise<CompetitionParticipant> {
    return this.api.post('competition/participate/' + competition.Id, {});
  }

  async getPromoted(): Promise<Competition> {
    return this.api.get('competition/promoted');
  }

  async getVisible(): Promise<boolean> {
    return this.api.get('competition/visible');
  }
}
